import { Pipe, PipeTransform } from '@angular/core';
import { Seasonality } from '../Model/Seasonality.model';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'seasonalityFilter',
  standalone: false
})
export class SeasonalityFilterPipe implements PipeTransform {

  constructor(private datePipe: DatePipe) { }

  transform(seasonalities: Seasonality[], searchTerm: string, field: string): Seasonality[] {
    if (!seasonalities || !searchTerm) return seasonalities;

    const lowerSearchTerm = searchTerm.toLowerCase();

    return seasonalities.filter(seasonality =>
      this.matchesSearchTerm(seasonality, lowerSearchTerm)
    );
  }

  private matchesSearchTerm(seasonality: Seasonality, term: string): boolean {
    return (
      this.stringMatches(seasonality.seasonalityCategoryCode, term) ||
      this.stringMatches(seasonality.marketCompanyLabel, term) ||
      this.stringMatches(seasonality.productCategoryLabel, term) ||
      this.stringMatches(seasonality.seasonalityCategoryLabel, term) ||
      this.stringMatches(seasonality.threshold?.toString(), term) ||
      this.dateMatches(seasonality.LastUpdateDate, term) ||
      this.stringMatches(seasonality.UserName, term) ||
      this.dateMatches(seasonality.applicationDate, term)
    );
  }

  private stringMatches(value: string | null | undefined, term: string): boolean {
    return value?.toLowerCase().includes(term) ?? false;
  }

  private dateMatches(date: string | number | Date | null | undefined, term: string): boolean {
    if (!date) return false;
    const formattedDate = this.datePipe.transform(date as string | number | Date, 'MMMM dd, yyyy');
    return formattedDate?.toLowerCase().includes(term) ?? false;
  }
}
